module.exports = __webpack_public_path__ + "static/media/sm1.211b6c82.jpg";